// extracted by mini-css-extract-plugin
export var button = "_c5-2";
export var iconWrapper = "_c5-0";
export var investigatingIcon = "_c5-1";